const UserMailing = {
  data: function () {
    return {
      mailing: { default: true, marketing: true, bookmarks: true },
    };
  },
  computed: {
    ...Vuex.mapState(['user']),
  },
  watch: {
    mailing: {
      deep: true,
      handler(value, before) {
        //si venía por defecto, nada
        if (before?.default) {
          return true;
        }
        //actualizamos valor
        this.update(value);
      },
    },
    user(value) {
      this.mailing = this.user.mailing;
    },
  },
  methods: {
    update(mailing) {
      axios
        .post('/usuarios/mailing/', { mailing })
        .then((result) => {
          customAlert('', 'Se han guardado tus preferencias');
        })
        .catch((err) => {
          customAlert(
            'Ha ocurrido un error',
            'No hemos podido actualizar tus preferencias, por favor inténtalo más tarde.',
          );
          console.error('Mailing KO!', err.response);
        });
    },
  },
  template: `
      <div class="user-mailing-form">
        <div class="">
          <label>
            <input class="uk-checkbox" type="checkbox" v-model="mailing.marketing">
            Quiero recibir electrónicos ocasionales con información acerca de como utilizar el sitio web y mejorar mi cuenta.
          </label>
        </div><div class="uk-margin-top">
          <label>
            <input class="uk-checkbox" type="checkbox" v-model="mailing.bookmarks">
            Quiero recibir correos electrónicos con las ofertas de trabajo que he guardado.
          </label>
      </div>
      </div>
	`,
};
